import { useEffect, useState, useRef, useMemo } from 'react';
import { Card, Row, Col, Form, Input, Button, Select } from 'antd';
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import  Validations from 'shared/validations/Validations.json';
import { useHistory, useLocation } from "react-router-dom";
import {getToday} from 'shared/utils/dateUtils';
import DeviceStatus from './DeviceStatus';

export default function SearchDeviceStatus() {

    const { search } = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(search), [search])
    const [endPoint, setEndPoint] = useState()
    const defaultExportFilename = `Report_${getToday().today}`
    const [form] = Form.useForm();
    const myRef = useRef();
    const history = useHistory();


    const formItemLayout = {
        labelCol: {
            span: 10
        },
        wrapperCol: {
            span: 12
        },
    };

    const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth' });
    const batteryVoltageSelectOptions = [{value:'Χαμηλό', label:'Χαμηλό'},{value:'Μεσαίο', label:'Μεσαίο'},{value:'Υψηλό', label:'Υψηλό'},{value:'Άγνωστο', label:'Άγνωστο'},{value:'ALL', label:'ALL'}]

    useEffect(() => {
        form.setFieldsValue({
            'policyNumber': queryParams.get('policyNumber'),
            'deviceImei': queryParams.get('deviceImei'),
            'batteryVoltage': queryParams.get('batteryVoltage') ? queryParams.get('batteryVoltage'):'ALL'
        })
        setEndPoint(`${EndPoints.REPORTS.BEACONBATTERY}?${queryParams.toString()}`);
    }, [queryParams, form])

    const onFinish = (fieldsValues) => {
        const values = {
            ...fieldsValues,
            'batteryVoltage': fieldsValues.batteryVoltage !== 'ALL' ? fieldsValues.batteryVoltage: null
        }
        Object.keys(values).forEach(key => values[key] === null || values[key] === undefined || values[key] === '' ? delete values[key] : values[key]);
        const params = new URLSearchParams(values);
        history.replace({ search: `?${params}` });
        setEndPoint(`${EndPoints.REPORTS.BEACONBATTERY}?${params}`);
        executeScroll();
    };

    return (
        <>
            <Card type="inner" headStyle={headerStyle} title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση" >
                <Row style={rowStyle}>
                    <Col style={{ color: 'black' }} span={24}>Κριτήρια Αναζήτησης</Col>
                </Row>
                <Form
                    {...formItemLayout}
                    form={form}
                    onFinish={onFinish}
                >
                    <Row>
                        <Col span={12} >
                            <Form.Item
                                label="Αριθμός Συμβολαίου:"
                                name="policyNumber"
                                rules={[{ pattern: new RegExp(Validations.POLICYNUMBER.REGEX), message: Validations.POLICYNUMBER.MESSAGE }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item
                            label="Device Imei:"
                            name="deviceImei"
                            rules={[{ pattern: new RegExp(Validations.BLUETOOTHDEVICEIMEI.REGEX), message: Validations.BLUETOOTHDEVICEIMEI.MESSAGE }]}
                           >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="batteryVoltage" label="Επίπεδο Μπαταρίας:" >
                                <Select defaultValue="ALL" options={batteryVoltageSelectOptions} />
                            </Form.Item>
                        </Col>
                        <Col span={8} offset={10} >
                            <Form.Item>
                                <Button htmlType="submit" style={{ backgroundColor: '#e6e6e6' }} >
                                    Αναζήτηση
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Col ref={myRef}>
                <DeviceStatus endPoint={endPoint} exportFilename={defaultExportFilename} />
            </Col>
        </>
    );
}